export function getQueryString(params: any) {
  // console.log('getQueryString: ', params)
  const queryString = [];
  for (const key in params) {
    if (params[key]) {
      queryString.push(key + "=" + params[key]);
    }
  }

  return queryString.join("&");
}

export function setQueryString(params: any, queries: any) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  queries.forEach((query: any) => {
    params[query.k] = urlParams.has(query.k) ? urlParams.get(query.k) : query.v;
  });
  // console.log('params', params)
  return params;
}
